import { render, staticRenderFns } from "./MentorFor.vue?vue&type=template&id=1253b1b7&scoped=true&"
import script from "./MentorFor.vue?vue&type=script&lang=js&"
export * from "./MentorFor.vue?vue&type=script&lang=js&"
import style0 from "./MentorFor.vue?vue&type=style&index=0&id=1253b1b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253b1b7",
  null
  
)

export default component.exports